
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 14","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M6.944.698l4.35 4.011c.409.378.706 1.055.706 1.61v6.016c0 .737-.599 1.332-1.336 1.332h-9.33A1.334 1.334 0 010 12.335V6.318c0-.554.298-1.232.707-1.609L5.056.7a1.403 1.403 0 011.888 0zm-.984.98L1.61 5.69c-.135.125-.277.447-.277.628v6.017h.132l.695-.001h8.504V12.308l.001-.384v-.071l.001-1.023V6.318c0-.181-.14-.503-.277-.628L6.04 1.679c-.017-.016-.063-.016-.08 0zm-.293 4.316c.184 0 .333.149.333.333v2.73c0 .184-.15.333-.333.333h-2.73a.333.333 0 01-.333-.333v-2.73c0-.184.149-.333.333-.333h2.73z"}})])
          )
        }
      }
    